import React from "react";
import { Box } from "@mui/material";

const wordmarkFont = '"Montserrat", sans-serif';

/** Wordmark only — yellow MY + red NET GOALS, no TV or football art. */
export default function BrandWordmark({ compact = false }) {
  const mySize = compact ? 13 : 16;
  const netSize = compact ? 14 : 17;

  return (
    <Box
      aria-label="My Net Goals"
      sx={{
        display: "inline-flex",
        flexDirection: "column",
        alignItems: "flex-start",
        filter: "drop-shadow(0 6px 16px rgba(0,0,0,0.45))",
      }}
    >
      <Box
        sx={{
          bgcolor: "#F5C518",
          color: "#1a2a6c",
          fontWeight: 800,
          fontFamily: wordmarkFont,
          fontStyle: "italic",
          fontSize: mySize,
          letterSpacing: "0.04em",
          lineHeight: 1,
          px: compact ? 0.9 : 1.15,
          py: compact ? 0.35 : 0.45,
          borderRadius: "4px",
          transform: "rotate(-5deg)",
          border: "1.5px solid #111",
        }}
      >
        MY
      </Box>
      <Box
        sx={{
          bgcolor: "#e31c3d",
          color: "#fff",
          fontWeight: 800,
          fontFamily: wordmarkFont,
          fontStyle: "italic",
          fontSize: netSize,
          letterSpacing: "0.06em",
          lineHeight: 1,
          px: compact ? 1.1 : 1.35,
          py: compact ? 0.4 : 0.5,
          borderRadius: "4px",
          mt: "-4px",
          ml: compact ? 1.4 : 1.8,
          border: "1.5px solid #111",
        }}
      >
        NET GOALS
      </Box>
    </Box>
  );
}
